export default "__VITE_ASSET__BnBkpiUd__"